import { PETERSBURG_AND_REGION } from '@/packages/Filters/shared/constants/regions';
import { getRegionId } from '@/packages/Filters/shared/utils/geo';
import { getRangeValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';
import { getRangeText } from '../utils/getRangeText';

export const fromMKADKm: ITagGroupConfig = {
  get({ jsonQuery, currentLocation }) {
    const fromMKAD = getRangeValue('from_mcad_km')(jsonQuery);
    const text = getRangeText(fromMKAD);
    const regionId = getRegionId(currentLocation);
    const prefix = PETERSBURG_AND_REGION.includes(regionId) ? 'от КАД' : 'от МКАД';

    if (!text) {
      return null;
    }

    return [
      {
        group: 'fromMKADKm',
        text: `${prefix} ${text} км`,
      },
    ];
  },
  delete({ onChange }) {
    onChange(
      {
        action: 'setFromMKADMin',
        arguments: [null],
      },
      {
        action: 'setFromMKADMax',
        arguments: [null],
      },
    );
  },
};
